module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "justify": "center",
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('login.welcome')))]), _vm._v(" "), _c('data-form', {
    attrs: {
      "entity": _vm.model,
      "fields": _vm.fields,
      "cancel": false,
      "loading": _vm.$store.state.progress >  0,
      "submit-label": "login"
    },
    on: {
      "submit": _vm.submit
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72c89b0c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 1167
// module chunks = 2